import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { SubjectLink } from 'app/shared/models/subject-link';
import { Subject } from 'app/shared/models/subject';
import { SubjectLinkService } from 'app/shared/services/subject-link.service';
import { LinkedSubjectsListComponent } from '../linked-subjects-list.component';
@Component({
  selector: 'subject-list-preview',
  templateUrl: './subject-list-preview.component.html',
  styleUrls: ['./subject-list-preview.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SubjectListPreviewComponent implements AfterViewInit {

  _subjects: Subject[] | SubjectLink[];

  @Input() set subjects(val: Subject[] | SubjectLink[]) {
    this._subjects = val;
    this.selectFirst();
  }
  @Input() allowEdit = false;
  @Input() allowDelete = false;
  @Input() readOnly = false;
  @Input() allowEditRelationship = false;
  @Input() noContentMessage = '';
  @Input() autoSelect = false;
  @Input() showLinkedSubjects = true;

  @Output() onSelect: EventEmitter<any> = new EventEmitter();
  @Output() onEdit: EventEmitter<any> = new EventEmitter();
  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() onChangeRelationship: EventEmitter<any> = new EventEmitter();

  subject: Subject;

  @ViewChild('linkedSubjectsList') linkedSubjects: LinkedSubjectsListComponent;

  constructor(private subjectLinkService: SubjectLinkService) { }

  ngAfterViewInit() {
    this.selectFirst();
  }

  private selectFirst() {
    if (this.autoSelect && this._subjects && (this._subjects.length > 0)) {
      const s = this._subjects[0];
      this.subjectLinkService.onSelected.next(s);
      if (s instanceof SubjectLink) {
        this.select(s);
      }
      else {
        this.subject = s;
      }
    }
  }

  select(subjectLink) {
    this.subject = subjectLink.linkedSubject;
    this.onSelect.emit(subjectLink);
  }

  edit(subjectLink) {
    this.onEdit.emit(subjectLink);
  }

  delete(subjectLink) {
    this.onDelete.emit(subjectLink);
  }

  changeRelationship(link) {
    if (this.allowEditRelationship) {
      this.onChangeRelationship.emit(link);
    }
  }
}
